/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Table, Skeleton, Empty, Modal, Input, Form, message } from "antd";
import { Avatar1, Avatar2, dotmenu, editarperfil, descartarperfil } from "../imagepath";
import { onShowSizeChange, itemRender } from "../Pagination";
import { Link } from "react-router-dom";
import Select from "react-select";
import FeatherIcon from "feather-icons-react";
import styles from "./PatientsList.module.css";
import {
  getPresumptivePatients,
  getPresumptivePatientsFilters,
  getNeighborhoods,
} from "../../services/patient";
import { DatePicker } from "antd";
import RegisterPatient from "./RegisterPatient";

const PatientPresumptive = () => {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  //Register Patient Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [patientModal, setPatientModal] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    manager: "",
    pathology: "",
    dateOfBirth: "",
    age: "",
    pss: {},
    pssId: "",
    municipality: {},
    municipalityId: "",
    neighboordhood: {},
    DemograficCd: "",
  });
  const [options, setOptions] = useState({});
  //State for Filters
  const [advanceMode, setAdvanceMode] = useState(false);
  const [filters, setFilters] = useState({
    pathologies: [],
    risks: [],
  });

  //Filters value
  const [searchText, setSearchText] = useState("");
  const [pathology, SetPathology] = useState([]);
  const [risk, setRisk] = useState([]);
  const [startdate, setStartDate] = useState();
  const [enddate, setEndDate] = useState();

  //Patients list
  const [datasource, setDatasource] = useState([]);

  //Functions
  const onClickAdvanceMode = () => {
    setAdvanceMode(!advanceMode);
  };
  const searchTextHandle = (event) => {
    setSearchText(event.target.value);
  };
  //Set Start Date and End Date Handlers
  const setStartDateHandler = (date, dateString) => {
    setStartDate(dateString);
  };
  const setEndDateHandler = (date, dateString) => {
    setEndDate(dateString);
  };

  //Modal functions
  const onClickRegisterPatient = (record) => {
    //Call Neighbors and later call the modal
    if (
      record.datosDemograficos != undefined &&
      record.datosDemograficos.municipioCd != undefined
    ) {
      getNeighborhoods(record.datosDemograficos.municipioCd).then((data) => {
        const neighboordhoods = data.map((item) => ({
          value: item.key,
          label: item.value,
        }));

        setOptions({
          ...options,
          neighboordhoods: neighboordhoods,
        });

        setPatientModal({
          InsuredMember: record.insuredMember,
          name: record.fullName,
          email: record.email,
          //Set Format Phone in (xxx) xxx-xxxx
          telephone: record.telephone.replace(
            /(\d{3})(\d{3})(\d{4})/,
            "($1) $2-$3"
          ),
          address: "",
          manager: "",
          pathologyId: record.pathologyId,
          currentPathology: record.pathology,
          dateOfBirth: record.birthday,
          age: record.age,

          address: record.datosDemograficos.direccion,
          municipalityId:
            record.datosDemograficos != undefined
              ? record.datosDemograficos.municipioCd
              : "",
          neighborhoodId:
            record.datosDemograficos != undefined
              ? record.datosDemograficos.datoDemograficoCd
              : "",
          gender: record.gender,
        });

        setIsModalOpen(true);
      });
    } else {
      setPatientModal({
        InsuredMember: record.insuredMember,
        name: record.fullName,
        email: record.email,
        //Set Format Phone in (xxx) xxx-xxxx
        telephone: record.telephone.replace(
          /(\d{3})(\d{3})(\d{4})/,
          "($1) $2-$3"
        ),
        address: "",
        manager: "",
        pathologyId: record.pathologyId,
        currentPathology: record.pathology,
        dateOfBirth: record.birthday,
        age: record.age,
        gender: record.gender
      });

      setIsModalOpen(true);
    }
  };

  const onCancelModalHandler = () => {
    setIsModalOpen(false);
  };
  const OnCompleteModal = async () => {
    setLoading(true);
    setIsModalOpen(false);
    await getPresumptivePatientsList(currentPage, 10);
    setLoading(false);
  };

  const onChangePage = (page, pageSize) => {
    setLoading(true);
    getPresumptivePatientsList(page, pageSize);
    setCurrentPage(page);
    setLoading(false);
  };

  const onSearch = async () => {
    setLoading(true);
    await getPresumptivePatientsList(1, 10);
    setLoading(false);
  };
  // Get Filters Options
  const getFiltersOptions = async () => {
    await getPresumptivePatientsFilters().then((response) => {
      const pathologies = response.pathologies.map((item) => ({
        value: item.key,
        label: item.value,
      }));

      const risks = response.risks.map((item) => ({
        value: item.key,
        label: item.value,
      }));

      const managers = response.managers.map((item) => ({
        value: item.key,
        label: item.value,
        pss: item.pss,
      }));

      const pss = response.pss.map((item) => ({
        value: item.key,
        label: item.value,
      }));

      const municipalities = response.municipios.map((item) => ({
        value: item.key,
        label: item.value,
      }));

      const generos = response.generos.map((item) => ({
        value: item.key,
        label: item.value,
      }));
      
      risks.unshift({ value: 0, label: "Todos" });
      setFilters({
        pathologies: pathologies,
        risks: risks,
        pss: pss,
        municipalities: municipalities,
      });

      setOptions({
        ...options,
        managers: managers,
        pathologies: pathologies,
        pss: pss,
        municipalities: municipalities,
        genders: generos
      });
    });
  };
  // Get Patients
  const getPresumptivePatientsList = async (page, pageSize) => {
    setDatasource([]);

    //Replace searchText "-" to "
    let searchTextReplace =
      searchText != undefined ? searchText.replaceAll("-", "") : searchText;
    const response = await getPresumptivePatients({
      pathologyId: pathology ? pathology.value : null,
      riskId: risk ? risk.value : null,
      searchText: searchTextReplace,
      fromDate: startdate,
      startDate: enddate,
      pageIndex: page,
      pageSize: pageSize,
    });

    setDatasource(response);
  };

  const columns = [
    {
      title: "Documento",
      dataIndex: "document",
      sorter: (a, b) => a.document.length - b.document.length,
      render: (text, record) => (
        <>
          <h2 className="profile-image">
            {record.document.replace(/(\d{3})(\d{7})(\d{1})/, "$1-$2-$3")}
          </h2>
        </>
      ),
    },
    {
      title: "Número Asegurado",
      dataIndex: "InsuredMember",
      sorter: (a, b) => a.insuredMember.length - b.insuredMember.length,
      render: (text, record) => (
        <>
          <h2 className="profile-image">{record.insuredMember}</h2>
        </>
      ),
    },
    {
      title: "Nombre",
      dataIndex: "Name",
      sorter: (a, b) => a.fullName.length - b.fullName.length,
      render: (text, record) => (
        <>
          <h2 className="profile-image">
            <Link to="#" className="avatar avatar-sm me-2">
              <img
                width={28}
                height={28}
                className="rounded-circle"
                src={record.gender === "F" ? Avatar1 : Avatar2}
                alt="#"
              />
            </Link>
            <Link to="#">{record.fullName}</Link>
          </h2>
        </>
      ),
    },
    //
    {
      title: "Edad",
      dataIndex: "age",
      sorter: (a, b) => a.age.length - b.age.length,
    },
    {
      title: "Patología",
      dataIndex: "pathology",
      sorter: (a, b) => a.pathology.length - b.pathology.length,
      render: (text, record) => (
        <>
          <span className="custom-badge status-green">{record.pathology}</span>
        </>
      ),
    },
    {
      title: "Riesgo",
      dataIndex: "risk",
      sorter: (a, b) => a.risk.length - b.risk.length,
      render: (text, record) => (
        <>
          <FeatherIcon
            icon="info"
            color={
              record.risk === "Alto"
                ? "red"
                : record.risk === "Medio"
                  ? "#ffc107"
                  : "#28a745"
            }
          />
          &nbsp;
          {record.risk}
        </>
      ),
    },
    {
      title: "Motivo de Reporte",
      dataIndex: "reportReason",
      sorter: (a, b) => a.reportReason.length - b.reportReason.length,
      render: (text, record) => (
        <>
          {record.reportReason}
          <br />
          Fecha Reporte: <b>{record.reportReasonDate}</b>
          <br />
          <span className="badge status-orange mx-1">
            {record.variableReportReason}
          </span>
          {/* {record.variableReportReason.map((item, index) => (
            <span key={index} className="badge status-orange mx-1">{item}</span>
          ))} */}
        </>
      ),
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text, record) => (
        <>
          <div className="text-end">
            <div className="dropdown dropdown-action">
              <Link
                to="#"
                className="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                 <img 
                width={12}
                height={12}
                className="fas"
                src={dotmenu} alt="" />
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
                <Link
                  className="dropdown-item"
                  to="#"
                  onClick={() => {
                    onClickRegisterPatient(record);
                  }}
                >
                  <img 
                  width={12}
                  height={12}
                  className="far me-2"
                  src={editarperfil} alt=""/> Registrar
                </Link>
                <Link
                  className="dropdown-item"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#delete_patient"
                >
                  <img 
                  width={12}
                  height={12}
                  className="fa m-r-5"
                  src={descartarperfil} alt=""/> Descartar
                </Link>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  // UseEffect for fetch data
  React.useEffect(() => {
    setLoading(true);
    getFiltersOptions();
    getPresumptivePatientsList(0, 10);
    setLoading(false);
  }, []);
  return (
    <>
      {/* Page Header */}
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="#">Pacientes </Link>
              </li>
              <li className="breadcrumb-item">
                <i className="feather-chevron-right" />
              </li>
              <li className="breadcrumb-item active">
                Listado de Pacientes Potenciales
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* End Page Header */}
      {/* Search Filters */}
      <div className="row">
        <div className="col-sm-12">
          <div className="card card-table show-entire">
            <div className="card-body">
              <div className="staff-search-table">
                {/* Basic Filters */}
                <div className="row">
                  <div className="col-12 col-md-4 col-xl-3">
                    <div className="form-group local-forms">
                      <label>Patologia</label>
                      <Select
                        defaultValue={pathology}
                        onChange={SetPathology}
                        options={filters.pathologies}
                        menuPortalTarget={document.body}
                        noOptionsMessage={() => "No hay opciones"}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        id="pathology"
                        className={styles.customSelectHeight}
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-5 col-xl-5">
                    <div className="table-search-blk">
                      <div className="form-group local-forms search-icon">
                        <form>
                          <input
                            type="text"
                            className={[
                              styles.backgroundText + " form-control",
                            ]}
                            onChange={searchTextHandle}
                            placeholder="Búsqueda por documento de identificación o nombre"
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-1 col-md-1 col-xl-1 mt-1">
                    <button
                      type="submit"
                      className={
                        advanceMode ? "btn btn-info" : "btn btn-outline-info"
                      }
                      onClick={onClickAdvanceMode}
                      title="Filtros Avanzados"
                    >
                      <i
                        className={
                          advanceMode
                            ? "feather-chevron-down"
                            : "feather-chevron-up"
                        }
                      >
                        <FeatherIcon
                          icon={advanceMode ? "chevron-down" : "chevron-up"}
                        />
                      </i>
                    </button>
                  </div>
                  <div className="col-12 col-md-3 col-xl-3">
                    <div className="doctor-submit">
                      <button
                        type="submit"
                        onClick={onSearch}
                        className="btn btn-primary submit-list-form me-2"
                      >
                        Buscar
                      </button>
                    </div>
                  </div>
                </div>
                {/* End Basic Filters */}
                {/* Advance Mode  */}
                {advanceMode && (
                  <div className="advance-filters">
                    <div className="row">
                      <div className="col-12 col-md-6 col-xl-3">
                        <div className="form-group local-forms">
                          <label>Riesgo</label>
                          <Select
                            defaultValue={risk}
                            onChange={setRisk}
                            options={filters.risks}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            id="ddlRisk"
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            className={styles.customSelectHeight}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-3">
                        <div className="form-group local-forms">
                          <label>Desde (Fecha de Motivo)</label>
                          <DatePicker
                            className="form-control datetimepicker"
                            onChange={setStartDateHandler}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-3">
                        <div className="form-group local-forms">
                          <label>Hasta (Fecha de motivo)</label>
                          <DatePicker
                            className="form-control datetimepicker"
                            onChange={setEndDateHandler}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Search Filters */}
      <div className="card card-table">
        <div className="card-body">
          <div className="table-responsive" style={{ margin: "10px" }}>
            {
              <Table
                pagination={{
                  pageSize: datasource.count,
                  total: datasource.pageCount,
                  showTotal: (total, range) =>
                    `Mostrando ${range[0]} de ${range[1]} de ${total} pacientes`,
                  onShowSizeChange: onShowSizeChange,
                  itemRender: itemRender,
                  onChange: onChangePage,
                }}
                columns={columns}
                dataSource={datasource.data}
                rowKey={(record) => record.id}
                locale={{
                  emptyText: loading ? (
                    <Skeleton active />
                  ) : (
                    <Empty description="No hay datos para mostrar" />
                  ),
                }}
              />
            }
          </div>
        </div>
      </div>

      <RegisterPatient
        affiliateData={patientModal}
        open={isModalOpen}
        onClose={onCancelModalHandler}
        OnCompleteModal={OnCompleteModal}
        options={options}
      />
    </>
  );
};

export default PatientPresumptive;
